import { ApiFundOfFundsPortfolio, ApiNewPortfolio, ApiSavedPortfolio } from '@/api'
import { PORTFOLIO_TYPE } from '@/constants'

export function mapToNewPortfolio(portfolio: ApiSavedPortfolio | null): ApiNewPortfolio {
  if (!portfolio) {
    throw new Error('Portfolio cannot be null')
  }

  const newPortfolio: ApiNewPortfolio = {
    portfolioName: portfolio.portfolioName,
    rebalancingDefinition: portfolio.rebalancingDefinition,
    targetWeights: portfolio.targetWeights.map(x => ({
      assetId: x.asset.assetId,
      weight: x.weight
    })),
    investmentWeights: (portfolio as ApiFundOfFundsPortfolio).investmentWeights?.map(x => ({
      assetId: x.assetId,
      weight: x.weight
    })),
    fees: portfolio.fees,
    allowedBusinessUnitIds: portfolio.allowedBusinessUnitIds,
    multiplier: portfolio.multiplier,
    disallowedStrategies: portfolio.disallowedStrategies,
    portfolioOwnerId: (portfolio as any).portfolioOwnerId,
    portfolioType: portfolio.type,
    ...(portfolio.type === PORTFOLIO_TYPE.FundOfFunds.key && {
      startDate: new Date().toISOString()
    })
  }
  return newPortfolio
}
